import * as React from "react";
import { connect } from "react-redux";
import ChemistProfile from "../../screens/Chemist/ChemistProfile";

import {
  ChemistUser,
  ChemistUserSlectedPage,
  ChemistInActive,
  ChemistOprMode,
  ChemistDetailsview,
  fetchchemistOfferDtls,
} from "./action";
class ChemistProfileContainer extends React.Component<Props, State> {
  render() {
    return (
      <ChemistProfile
        ChemistUser={this.props.ChemistUser}
        chemistuserDtlsList={this.props.chemistuserDtlsList}
        chemistuserDtlsCount={this.props.chemistuserDtlsCount}
        ChemistUserSlectedPage={this.props.ChemistUserSlectedPage}
        ChemistInActive={this.props.ChemistInActive}
        ChemistOprMode={this.props.ChemistOprMode}
        ChemistDetailsview={this.props.ChemistDetailsview}
        chemistmainDtls={this.props.chemistmainDtls}
        fetchchemistOfferDtls={this.props.fetchchemistOfferDtls}
        chemistOfferDtls={this.props.chemistOfferDtls}
        chemistOfferDtlsCount={this.props.chemistOfferDtlsCount}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    ChemistUser: (value) => {
      dispatch(ChemistUser(value));
    },
    ChemistUserSlectedPage: (value) => {
      dispatch(ChemistUserSlectedPage(value));
    },
    ChemistInActive: (value) => {
      dispatch(ChemistInActive(value));
    },
    ChemistOprMode: (value) => {
      dispatch(ChemistOprMode(value));
    },
    ChemistDetailsview: (value) => {
      dispatch(ChemistDetailsview(value));
    },
    fetchchemistOfferDtls: (value) => {
      dispatch(fetchchemistOfferDtls(value));
    },
  };
}
const mapStateToProps = (state) => {
  return {
    chemistuserDtlsList: state.ChemistReducer.chemistuserDtlsList,
    chemistuserDtlsCount: state.ChemistReducer.chemistuserDtlsCount,
    chemistmainDtls: state.ChemistReducer.chemistmainDtls,
    chemistOfferDtls: state.ChemistReducer.chemistOfferDtls,
    chemistOfferDtlsCount: state.ChemistReducer.chemistOfferDtlsCount,
  };
};

export default connect(mapStateToProps, bindAction)(ChemistProfileContainer);
